import { useTranslation } from "react-i18next";
import { usePbjNetwork } from "./PbjNetworkContext";

/** What a PBJ data tab is showing: the header department, every network building, or the Building filter's pick. */
export const useScopeLabel = (): string => {
	const { t } = useTranslation();
	const { isNetwork, buildings, buildingName, homeDepartmentId, selectedBuildingIds } = usePbjNetwork();
	if (!isNetwork) return buildingName(homeDepartmentId);
	if (selectedBuildingIds.size === 0) return t("pbj_model.network.scope.all_buildings", { count: buildings.length });
	if (selectedBuildingIds.size === 1) return buildingName([...selectedBuildingIds][0]);
	return t("pbj_model.network.scope.some_buildings", { count: selectedBuildingIds.size, total: buildings.length });
};
